<template>
  <header class="header clear-after">
    <a href="https://jeep.co.nz" target="_blank" class="logo">
      <img alt="Jeep logo" src="../assets/logo-left.png">
      <p>Return to <strong>Jeep.co.nz</strong></p>
    </a>

    <router-link to="/" class="button button-grey icon-left" :class="{ 'showme': $route.path != '/' }">
      <span class="icon"><img src="../assets/icon-back.svg"></span>
      <span class="text">RETURN TO GALLERY</span>
    </router-link>

    <img src="@/assets/gygo.svg" class="grill-on">
  </header>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../scss/variables.scss";
header.header {
  position: relative;
  padding: 20px 3%;

  text-align: center;
  background: black;

  @media (min-width: $mediumish) {
    height: 80px;
  }

  .logo {
    float: left;
    margin-top: 5px;

    @media (min-width: $medium) {
      margin-top: 0;
    }

    img {
      display: inline-block;
      vertical-align: bottom;
      height: 26px;
      margin-right: 10px;
      @media (min-width: $medium) {
        height: 36px;
      }
    }

    p {
      display: inline-block;
      width: 60px;
      margin: 0;

      font-size: 12px;
      font-weight: 700;
      line-height: 15px;
      color: white;

      strong {
        color: $color-1;
      }
    }
  }

  // h1 {
  //   position: absolute;
  //   top: 12px;
  //   left: 0;
  //   right: 0;

  //   margin: auto;
  //   // font-family: "Leviathan - HTF - Black";
  //   font-size: 48px;
  //   font-weight: 900;
  //   line-height: 50px;
  //   text-transform: uppercase;
  //   text-shadow: 0 0 7px #000000;
  //   color: white;
  // }

  img.grill-on {
    max-width: 355px;
    margin: auto;
    padding: 30px 0 0;
    @media (min-width: $smallish) {
      float: left;
    }
    @media (min-width: $mediumish) {
      position: absolute;
      top: 28px;
      left: 0;
      right: 0;
      margin: auto;
      padding: 0;
    }
    @media (min-width: $largeish) {
      top: 21px;
      max-width: 100%;
    }
  }

  .button {
    float: right;
    display: none;

    &.showme {
      display: block;
    }
  }
}
</style>
